import { render } from "./bottom.vue?vue&type=template&id=f8f6e254&scoped=true"
const script = {}

import "./bottom.vue?vue&type=style&index=0&id=f8f6e254&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8f6e254"]])

export default __exports__